class Filter {
    private options: NodeListOf<HTMLLinkElement>;
    private variants: NodeListOf<HTMLElement>;
    private currentVariant: HTMLLinkElement | null = null;

    constructor(private element: HTMLElement) {
        this.init();
    }

    private init() {
        this.options = this.element.querySelectorAll<HTMLLinkElement>('.filter-option');
        this.variants = this.element.querySelectorAll<HTMLElement>('.archive-products .archive-products-part');

        this.onScroll();
    }

    private toggle(option: HTMLLinkElement) {
        this.options.forEach(otherOption => {
            otherOption.classList.remove('active');
        });

        option.classList.add('active');
        this.currentVariant = option;
    }

    private onScroll() {
        window.addEventListener('scroll', () => {
            let closestVariant: HTMLLinkElement | null = this.currentVariant;
            let closestDistance = Infinity;

            let atTop = window.scrollY === 0;


            if (atTop) {
                closestVariant = this.element.querySelector('.archive-products');
            } else {
                this.variants.forEach(variant => {
                    const rect = variant.getBoundingClientRect();
                    const distance = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestVariant = variant as HTMLLinkElement;
                    }
                });
            }

            if (closestVariant !== this.currentVariant) {
                let variantName = closestVariant ? closestVariant.id : null;

                if (!variantName) {
                    variantName = 'all';
                }

                const variantOption = this.element.querySelector<HTMLLinkElement>(`.filter-option[data-filter="${variantName}"]`);

                if (variantOption) {
                    this.toggle(variantOption);
                    this.currentVariant = closestVariant;
                }
            }
        });
    }
}

window.addEventListener('load', () => {
    const archive = document.querySelector<HTMLElement>('.taxonomy-archive');

    if (archive) {
        new Filter(archive);
    }
});